import { moment } from "components/tdc-core/utils/commonUtils"
import { isset } from "./validate"

//Default: not pass
export const isPassDueDate = (date) => (isset(date) ? moment(date).isBefore(moment()) : false)

export const isNotYetStarted = (date) => (isset(date) ? moment(date).isAfter(moment()) : false)
